import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postUpdateUserChatDenialByAdmin
 *
 * Update chat denial settings.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param id Target user id.
 * @param denial Boolean of chat allow or denial.
 * @returns Update result.
 */

export const postUpdateUserChatDenialByAdmin = async (
  auth_token: string,
  id: string,
  denial: boolean
) => {
  try {
    const res = await axios.post(
      getAPIRoot(APIRoutes.post.chat_denial, "admin"),
      {
        sonic_id: id,
        sonic_chat_denial: denial,
      },
      {
        headers: {
          "X-Sonic-Auth": auth_token,
        },
      }
    );

    if (res.data.result !== null) {
      return res.data.message;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
